import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { HeaderOptions } from './types';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() options: HeaderOptions = {
    title: '',
  };
}
